export default __webpack_public_path__ + "static/media/practicelocationicon.0b53894b.svg";